<template>
  <section class="task-wrap" :style="dBHeight">
    <modals-container @updateRole="getRoleList" @registRole="getRoleList"></modals-container>
    <div class="tab_ty1">
      <AuditTab :currentTab="0" />
      <div class="tab-content">
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="0" :currentTab2="0" />
            <div class="tab-content">
              <div>
                <div class="tb-list_ty1 audit003">
                  <div class="tb-header clear">
                    <div class="tb_num fl">
                      <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건',{cnt:totalCount})">
                      </div>
                    </div>
                    <div class="btnDiv fr">
                      <button
                        type="button"
                        class="btn-primary-small"
                        @click="roleSetting('regist')"
                      >{{$i18nUtil.trans("message.RoleSetting.001","권한 등록")}}
                      </button>
                    </div>
                    <div class="search_ty2" style="float: right;padding-right: 20px;">
                      <input
                        type="text"
                        required
                        :placeholder="$i18nUtil.trans('message.RoleList.005','권한명 검색')"
                        v-model="searchUser"
                        @keyup.enter="[changePage(), getRoleList()]"
                      />
                      <button
                        type="button"
                        class="input-txt"
                        @click="[changePage(), getRoleList()]"
                      >{{$i18nUtil.trans("search.039","검색")}}
                      </button>
                    </div>
                  </div>

                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="roleList"
                    hide-default-footer
                    class="tb-contents"
                  >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <div>
                          <span class="ell-singleline d-block cursor-pointer" @click="roleSetting(item)">
                            {{ item.roleId }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="ell-singleline d-block cursor-pointer" @click="roleSetting(item)">
                            {{ item.roleName }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="ell-singleline d-block cursor-pointer" @click="roleSetting(item)">
                            {{ item.description }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span >{{ item.useYn ? $i18nUtil.trans('message.RoleManage.004','사용') : $i18nUtil.trans('message.RoleManage.005','미사용') }}</span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <button
                                type="button"
                                class="btn-primary-small"
                                @click="deleteRole(item.roleId)"
                                style="right: -100px"
                          >{{$i18nUtil.trans("button.delete","삭제")}}
                          </button>
                        </div>
                      </td>
                    </tr>
                  </template>

                  <template slot="no-data">
                    <div class="nodata-txt-noicon">
                      <v-alert :value="true">
                        {{$i18nUtil.trans("message.RoleList.001","권한 리스트가 없습니다.")}}
                      </v-alert>
                    </div>
                  </template>
                  </v-data-table>

                  <div v-show="pageCount > 0" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getRoleList"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import RoleSetting from "./modal/RoleSetting";

export default {
  components: {
    AuditSubTab,
    AuditTab,
    RoleSetting,
  },
  data() {
    return {
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      enabled: true,
      show: false,
      page: 1,
      pageCount: 0,
      totalCount: 0,
      itemsPerPage: 10,
      singleSelect: false,
      selected: [],
      roleList: [],
      searchUser: "",
      authorize: "",
      headers: [
        { text: this.$i18nUtil.trans("message.RoleManage.001","권한아이디"), value: "roleId", sortable: false },
        { text: this.$i18nUtil.trans("message.RoleManage.002","권한명"), value: "roleName", sortable: false },
        { text: this.$i18nUtil.trans("message.RoleManage.003","권한설명"), value: "description", sortable: false },
        { text: this.$i18nUtil.trans("message.RoleList.002","사용여부(사용/미사용)"), value: "useYn", sortable: false },
        { text: this.$i18nUtil.trans("button.delete","삭제"), sortable: false },
      ],
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  created() {
    this.getRoleList();
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    /* 권한 리스트 조회 */
    getRoleList() {
      let obj = this;

      let reqData = {};
      reqData.params = {
        currentPage: obj.page,
        itemsPerPage: obj.itemsPerPage,
        searchUser: obj.searchUser,
      };
      reqData.url = "/api/org/role/getRoleList";
      reqData.method = "post";
      
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
            obj.authorize = res.errorCode;
          } else {
            obj.roleList = res.result.roleList;
            obj.totalCount = res.result.roleCount;
            obj.pageCount = res.result.rolePageCount;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    roleSetting(item) {
      if(this.authorize != "NOT_AUTHORIZED"){
        if(item == 'regist'){
          const modalInfo = {
          obj: this.$modal,
          component: RoleSetting,
          width: "1220px",
          height: "500px",
          status: item,
        };
        this.showModal(modalInfo);
        }else{
          const modalInfo = {
          obj: this.$modal,
          component: RoleSetting,
          width: "1220px",
          height: "500px",
          roleId: item.roleId,
          roleName: item.roleName,
          description: item.description,
        };
        this.showModal(modalInfo);
        }
      }
    },
    changePage() {
      this.page = 1;
    },
    deleteRole(item){                      
      /* 권한 삭제 */
      if (confirm(this.$i18nUtil.trans("message.RoleList.003","권한을 삭제하시겠습니까?"))) {
        let obj = this;
        let reqData = {};
        reqData.url = "/api/org/role/deleteRole";
        reqData.method = "post";
        reqData.params = {
          roleId: item,
        };
        //프로그레스바 시작
        this.showLoadingbar();
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            //프로그레스바 종료
            this.hideLoadingbar();
            if (res.errorCode) {
              console.log(res.errorCode);
            } else {              
              obj.toastInfo.message = obj.$i18nUtil.trans("message.RoleList.004","권한이 삭제되었습니다.");
              obj.showToast(obj.toastInfo);
              this.getRoleList();
            }
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      }        
    },    
  },
};
</script>

<style scoped>
.audit003 {
  margin-top: 38px;
}
.audit003 >>> th:nth-child(1),
.audit003 >>> td:nth-child(1) {
  text-align: left;
  width: 160px !important;  
}
.audit003 >>> th:nth-child(2),
.audit003 >>> td:nth-child(2) {
  text-align: left;
  width: 375px !important;
}
.audit003 >>> th:nth-child(3),
.audit003 >>> td:nth-child(3) {
  text-align: left;
  width: 375px !important;
}
.audit003 >>> th:nth-child(4),
.audit003 >>> td:nth-child(4) {
  text-align: center;
  width: 150px !important;
}
.audit003 >>> th:nth-child(5),
.audit003 >>> td:nth-child(5) {
  text-align: center;
  width: 120px !important;  
}

.audit003 >>> input {
  background-color: transparent;
}
.audit003 >>> th:nth-child(1) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(2) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(3) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(4) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(5) > span {
  margin-left: 40px;
}

.audit003 >>> td:nth-child(1) > div > span {
  text-align: left;
  margin-left: 30px;
  width: 130px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(2) > div > span {
  text-align: left;
  margin-left: 30px;
  width: 345px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(3) > div > span {
  text-align: left;
  margin-left: 30px;
  width: 345px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(4) > div > span {
  margin-left: 30px;
  width: 120px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(5) > div > button {
  margin-left: 37px;  
}
.audit003 >>> tbody::after {
  background: none;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/RoleList.vue